import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Box, Flex, Text } from "rebass";
import { css } from "styled-components";
import { MdChevronRight, MdFolder } from "react-icons/md";

import { StyledLink } from "./StyledLink";

import { ROOT_FOLDER } from "../../../../store/modules/library/constants";
import { getUser } from "../../../../store/modules/session/selectors";

import { useSubscribeInstanceLength } from "../../../hooks/useSubscribeInstanceLength";

const textCSS = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export type FolderComponentInputProps = {
  folder: {
    id: string,
    title: string,
    books?: Record<string, string>,
    folders?: Record<string, string>,
  };
};

export const FolderLink: React.FC<FolderComponentInputProps> = (
  {
    folder: {
      id,
      title,
      books,
      folders,
    },
  }
) => {
  const user = useSelector(getUser);
  const folderPath = useMemo(() => `/folders/${user && id === ROOT_FOLDER ? user.uid : id}`, [id, user]);
  const booksLength = useSubscribeInstanceLength(`${folderPath}/books`, books);
  const foldersLength = useSubscribeInstanceLength(`${folderPath}/folders`, folders);

  const numberOfItems = booksLength + foldersLength;

  return (
    <StyledLink to={id !== ROOT_FOLDER ? `/folder/${id}` : "/"}>
      <Flex
        p="12px"
        justifyContent="center"
        alignItems="center"
        bg="#f9eff6"
        color="viola"
        css="border-radius: 50%;"
      >
        <MdFolder display="block" size={36} fill="currentColor" />
      </Flex>

      <Box
        flex="1"
        ml="17px"
        mr="5px"
        css="overflow: hidden;"
      >
        <Text
          width={1}
          mb="5px"
          fontSize="18px"
          fontWeight="bold"
          color="zodiac"
          css={textCSS}
        >
          {title}
        </Text>

        <Text
          fontSize="14px"
          color="#7b80aa"
        >
          {`${numberOfItems} items`}
        </Text>
      </Box>

      <Box alignSelf="center" ml="auto" color="wild-blue">
        <MdChevronRight size={24} />
      </Box>
    </StyledLink>
  );
};
